/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
// eslint-disable-next-line jira/restricted/react-redux
import {
	connect as connect8,
	Provider as Provider8,
	useStore,
	useSelector,
	useDispatch,
	type Connect,
	type ConnectedComponent,
	type DispatchProp,
	type InferableComponentEnhancerWithProps,
	type Matching,
	type ProviderProps as ProviderProps8,
	type ReactReduxContextValue,
} from 'react-redux';
// eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux
import type { AnyAction } from 'redux';
import { withStability } from './redux-stability.tsx';
import { mapStateToPropsWithErrorHandling } from './utils.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export type {
	// eslint-disable-next-line jira/export/restrict-types-re-export
	Connect,
	// eslint-disable-next-line jira/export/restrict-types-re-export
	ConnectedComponent,
	// eslint-disable-next-line jira/export/restrict-types-re-export
	DispatchProp,
	// eslint-disable-next-line jira/export/restrict-types-re-export
	InferableComponentEnhancerWithProps,
	// eslint-disable-next-line jira/export/restrict-types-re-export
	Matching,
	// eslint-disable-next-line jira/export/restrict-types-re-export
	ProviderProps8 as ProviderProps,
	// eslint-disable-next-line jira/export/restrict-types-re-export
	ReactReduxContextValue,
};
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { useStore, useSelector, useDispatch };
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { extractFactoryFunction, mapStateToPropsWithErrorHandling } from './utils';

// oxlint-disable-next-line typescript/consistent-type-assertions
export const connect: Connect = ((
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	mapStateToProps?: any,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	mapDispatchToProps?: any,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	mergeProps?: any,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	options: any = Object.freeze({}),
) =>
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	(component: any) => {
		const { context, storeKey, forceV8, skipStability, ...restOptions } = options;
		const stabilizedMapping = skipStability
			? mapStateToProps
			: withStability(component, 'mapStateToProps', mapStateToProps);
		const stabilizedMergeProps = skipStability
			? mergeProps
			: withStability(component, 'mergeProps', mergeProps);
		const safeMapStateToProps = mapStateToPropsWithErrorHandling(stabilizedMapping);

		const ResultComponent = connect8(
			safeMapStateToProps,
			mapDispatchToProps,
			stabilizedMergeProps,
			{
				context,
				...restOptions,
			},
		)(component);
		ResultComponent.displayName = `Connect(${component.displayName || component.name || typeof component})`;
		return ResultComponent;
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	}) as any;

// TODO: once all legacy context is removed from JFE, Provider5 can be fully removed. https://jplat.jira.atlassian.cloud/browse/MAGMA-2257
// subsequently, Provider5 can be removed from this file
/**
 * @deprecated this includes Redux5 provider that should be fully deprecated by now
 * migrate to Provider
 */

export const Provider8Wrapped = ({
	store,
	children,
	context,
}: // oxlint-disable-next-line @typescript-eslint/no-explicit-any
ProviderProps8<AnyAction, any>): React.JSX.Element => (
	<Provider8 store={store} context={context}>
		{children}
	</Provider8>
);

/**
 * Enhances a component with feature flagging, enabling conditional rendering between
 * react-redux v5 and v8 Provider
 */
export const Provider: typeof Provider8 = Provider8;

const makeWrappedProvider8 =
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	(context: ProviderProps8['context']) => (props: ProviderProps8<AnyAction, any>) => (
		<Provider context={context} {...props} />
	);

export const createProvider = (
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	context: ProviderProps8<AnyAction, any>['context'],
): ((
	props: // oxlint-disable-next-line @typescript-eslint/no-explicit-any
	ProviderProps8<AnyAction, any>,
) => React.JSX.Element) => makeWrappedProvider8(context);
